import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showBottom:true
  },
  getters: {
    showBottom: state =>state.showBottom
  },
  mutations: {
    SET_SHOW_BOTTOM:(state, value)=>{
      state.showBottom=value
    }
  },
  actions: {
    setShowBottom({commit},value){
      commit('SET_SHOW_BOTTOM', value)
    }
  },
  modules: {
  }
})
